/**
 *  @namespace account/details
 */
import { defaultTo, lensProp, over, pick, pipe, prop, renameKey, test } from '~/utils/lib/core/prelude'
import Request from '~/utils/infra/account/request'

/**
 * @typedef AccountDetails
 * @property {import('~/stores/client/admin').compte_id} id
 * @property {string} login
 * @property {string} mail
 * @property {string} prenom // since aclv3 new user has prenom but legacy user has mempty ""
 * @property {string} nom // for legacy user before acl v3 nom = "nom + prenom"
 */

/**
 * @typedef {Object} ClientAccountDetails
 * @property {string} uuid_data
 * @property {string} raison_sociale
 * @property {string} mail
 * @property {string} [telephone]
 */

export const useStore_account_details = defineStore('account/details', {
  state: () => (/** @type {AccountDetails & { clientAccounts: ClientAccountDetails[] }}  */ ({
    id: '',
    login: '',
    mail: '',
    nom: '',
    prenom: '',
    clientAccounts: [],
  })),
  getters: {
    hasFlaggedFeatureAccess(state) {
      return isGHS(state)
    },
  },
  actions: {
    /// Actions
    ///
    /**
     * @function hydrate
     */
    hydrate() {
      const request = new Request({
        method: 'get',
        route: 'v2/qui_suis_je'
      })
      return request.authorize().exec()
        .then(data => {
          const accountDetails = parseFromRemoteToClient_(data)
          const clientAccounts = parseClientAccountsFromRemote(data)

          this.$patch({
            ...accountDetails,
            clientAccounts
          })
        })
    }
  }
})

const pickAccountFields = pipe(
  pick(
    [
      '_id',
      'mail',
      'login',
      'nom',
      'prenom',
    ]
  ),
  renameKey('_id', 'id'),
)

/** @type {(_: any) => AccountDetails} */
const parseFromRemoteToClient = pipe(
  prop('compte'),
  pickAccountFields,
  over(lensProp('prenom'), defaultTo('')),
  over(lensProp('nom'), defaultTo('')),
)

/** @type {(_: any) => AccountDetails} */
const parseFromRemoteToClient_ = pipe(
  prop('data'),
  prop('compte'),
  pickAccountFields,
)

/** @type {(_: any) => ClientAccountDetails[]} */
const parseClientAccountsFromRemote = pipe(
  prop('data'),
  prop('compte_infos_by_uuid_data'),
  defaultTo([]),
)
/**
 * @NOTE not the best setup → better relying on a remote flag?
 * @type {(_: AccountDetails) => boolean}
 */
const isGHS = pipe(
  prop('mail'),
  test(/@ghs.fr$/),
)
